import styled from "styled-components";

const FeaturesStyleWrapper = styled.section`
  padding-top: 132px;
  padding-bottom: 100px;

  .features_items_row {
    row-gap: 30px;
    margin-top: 60px;
  } 
 
`;

export default FeaturesStyleWrapper;
